import LegacyRouteRedirect from '@/components/navigation/LegacyRouteRedirect';
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const PartnersListPage = lazy(() => import('./pages/PartnersListPage'));
const PartnerEditPage = lazy(() => import('./pages/PartnerEditPage'));
const PartnerUsersPage = lazy(() => import('./AdminPartnerUsersPage'));
const CategoriesPage = lazy(() => import('./pages/CategoriesPage'));
const InquiriesListPage = lazy(() => import('./pages/InquiriesListPage'));
const InquiryDetailPage = lazy(() => import('./pages/InquiryDetailPage'));

/**
 * Partner Management Routes
 * Admin interface for managing Partner users and B2B content
 */
const partnersRoutes: FuseRouteItemType[] = [
	{
		path: 'partners',
		auth: ['Admin'],
		children: [
			{ index: true, element: <LegacyRouteRedirect to="/partners/companies" /> },
			{
				path: 'companies',
				element: <PartnersListPage />
			},
			{
				path: 'companies/new',
				element: <PartnerEditPage />
			},
			{
				path: 'companies/:id/edit',
				element: <PartnerEditPage />
			},
			{
				path: 'users',
				element: <PartnerUsersPage />
			},
			{
				path: 'categories',
				element: <CategoriesPage />
			},
			{
				path: 'inquiries',
				children: [
					{
						path: '',
						element: <InquiriesListPage />
					},
					{
						path: ':id',
						element: <InquiryDetailPage />
					}
				]
			}
		]
	}
];

export default partnersRoutes;
